/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useContext } from 'react';
import classNames from 'classnames/bind';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { RebateCenterMetadata } from '@thd-olt-component-react/metadata';
import { RebateListings } from '@thd-olt-component-react/rebate-listings';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Typography } from '@one-thd/sui-atomic-components';

const REBATE_CENTER_DESC = 'Looking for rebates in your area? Search and track over one'
  + ' million eligible online items both Residential and Commercial at The Home Depot Rebate Center.';

const rebateCenterMetadataProps = {
  alternateUrlEnCa: 'https://www.homedepot.ca/en/home/promotions-and-offers/rebates/',
  alternateUrlFrCa: 'https://www.homedepot.ca/fr/accueil/promotions-et-offres/rabais/',
  data: {
    canonicalURL: '/rebate-center/index.html',
    description: REBATE_CENTER_DESC,
    siteName: 'The Home Depot',
    fbAdmins: '100005416960152',
    title: 'Rebate Center - The Home Depot',
    type: 'Content'
  },
  title: 'Rebate Center - The Home Depot',
  description: REBATE_CENTER_DESC
};

export const RebateCenter = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const breadcrumbs = [
    {
      label: 'Rebate Center',
      url: '/rebate-center/index.html'
    }
  ];

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('rebate-center.page-load', {});
  }, []);

  const rebateListingStyles = classNames({
    'sui-p-0': isMobile
  });

  return (
    <QueryProvider cacheKey="Rebate-Center">
      <article
        className="sui-flex sui-flex-col sui-p-3 sui-max-w-[1440px] sui-mx-auto"
        data-testid="rebate-center"
      >
        <ErrorBoundary name="metadata">
          <RebateCenterMetadata {...rebateCenterMetadataProps} />
        </ErrorBoundary>
        <ErrorBoundary name="breadcrumbs">
          <Breadcrumbs staticCrumbs={breadcrumbs} />
        </ErrorBoundary>
        <ErrorBoundary name="heading">
          <div className="sui-pt-3 sui-pb-6">
            <Typography variant="h3" weight="display">
              Rebate Center
            </Typography>
          </div>
        </ErrorBoundary>
        <div className={rebateListingStyles}>
          <ErrorBoundary name="rebate-listings">
            <RebateListings />
          </ErrorBoundary>
        </div>
      </article>
    </QueryProvider>
  );
};
RebateCenter.displayName = 'RebateCenter';
